import type { RootState } from 'store'

export const getProduct = (state: RootState) => state.addELabelModal.product
export const getStep = (state: RootState) => state.addELabelModal.step
export const getOpenedStep = (state: RootState) =>
  state.addELabelModal.openedSteps
export const getSettings = (state: RootState) => state.addELabelModal.settings
export const getELabel = (state: RootState) => state.addELabelModal.eLabel
export const getGTINError = (state: RootState) => state.addELabelModal.gtinError
